import axios from 'axios';
import queryString from 'query-string';
import tokenService from './token.service.js';
import { decode } from 'js-base64';
import { appConfig } from '../config/appConfig.js';
import { isErrorExist } from '../utils/validAndTest.js';

class SessionService {
    constructor() {
        this.params = queryString.parse(window.location.search || window.location.hash);
    }

    accessToken() {
        return tokenService.getLocalAccessToken('accessToken');
    }

    accessTokenWithoutBearer() {
        return tokenService.getLocalAccessTokenWithoutBearer('accessToken');
    }

    idToken() {
        return tokenService.getLocalAccessToken('idToken');
    }

    isError() {
        return tokenService.getErrorData();
    }

    isState() {
        return tokenService.getRequestForEdit();
    }

    authenticate = async () => {
        const { error, error_description, code, state } = this.params;

        if (error || error_description) {
            tokenService.setErrorData(true);
            window.location.replace(this.redirectUri());
        } else if (code) {
            if(state){
                let decodedValue = decode(state);
                tokenService.setStateData(decodedValue);
            }
            await this.getLCSToken(code);
        }
    };

    getLCSToken = async (code) => {
        const body = new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: tokenService.getFromMobile()?appConfig.CLIENT_ID_MOBILE:appConfig.CLIENT_ID_WEB,
            code,
            redirect_uri: this.redirectUri(),
        }).toString();

        const url = new URL(`${appConfig.COGNITO_URL}/oauth2/token`);

        try {
            const response = await axios.post(url.toString(), body, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow',
            });

            const expiresAt = Date.now() + (response.data.expires_in * 1000);
            response.data.expires_in = expiresAt;

            sessionStorage.setItem('user', JSON.stringify(response.data));
            tokenService.removeErrorData();
            window.location.replace(this.redirectUri());
        } catch (error) {
            if(isErrorExist(error?.response?.status)) {
                tokenService.setErrorData(true);
                window.location.replace(this.redirectUri());
            }
        }
    };

    redirectUri = () => {
        return `${window.location.protocol}//${window.location.host}`;
    };
}

export default new SessionService();
